import * as React from 'react';
import styles from './GroupingPage.scss';
import { groupBundlesByName } from '~/utils/bundles';
import CategoryHotLink from '~/components/CategoryHotLink/CategoryHotLink';
import equal from 'fast-deep-equal/react';
import { useAppSelector } from '~/Store';
import { useAvailableSound } from '~/hooks/useAvailableSound';
import Bundle from './Bundle/Bundle';
import { isChina, isSafariBrowser } from '~/utils/settings';
import Account from '~/account/Account';
import Attention from '~/components/Attention/Attention';
import { t } from '~/utils/localization';
import { redirectToLogin } from '~/utils/utils';
import isDisabledAnimation from '~/hooks/isDisabledAnimation';
import { isVideoTypeSupported } from '~/utils/video';
import classNames from 'classnames';
import EasterEgg from './EasterEgg/EasterEgg';

export interface IPromoPage {
    bundles: number[];
}

const GroupingPage = ({ bundles }: IPromoPage) => {
    const categories = useAppSelector((state) => state.app.categories, equal);
    const currentPage = useAppSelector((state) => state.app.currentPage, equal);
    const isVisiblePopup = useAppSelector((state) => state.app.popupActive, equal);
    const groups = groupBundlesByName(bundles);
    const refs = React.useRef<Map<string, HTMLDivElement>>(new Map<string, HTMLDivElement>());
    const allNames = Object.keys(groups);
    const isCn = isChina();
    const category = categories?.[currentPage?.name];
    const isAvailableSoundEffect = useAvailableSound(categories?.[currentPage?.name], null);
    const isHiddenProductsInfo = isCn && category?.isContainBundlesForReal && !Account.getAccount()?.id;
    const _isDisabledAnimation = !isVideoTypeSupported('webm') || isSafariBrowser ? true : isDisabledAnimation(category?.theme);

    if (!category) {
        return <></>;
    }

    const classesBundles = classNames(styles.bundles, {
        [styles.lonelyBundle]: allNames.length === 1,
    });

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                {!!category?.hotLinks?.length && (
                    <div className={styles.switcher}>
                        {category.hotLinks.map((link) => {
                            if (link.linkType === 'category' && !categories[link.linkValue]) {
                                return null;
                            }
                            return (
                                <CategoryHotLink
                                    key={`hot_link_to_${link.linkValue}`}
                                    link={link}
                                    className={styles.hotLink}
                                    wrapperClassName={styles.hotLinkWrapper}
                                    labelClassName={styles.hotLinkLabel}
                                />
                            );
                        })}
                    </div>
                )}
                <div className={classesBundles}>
                    {allNames.map((group: string, index) => {
                        return (
                            <Bundle
                                groupName={group}
                                groups={groups}
                                isLonelyBundle={allNames.length === 1}
                                isHalfBundle={allNames.length === 2}
                                isDisabledAnimation={_isDisabledAnimation}
                                isHiddenProductsInfo={isHiddenProductsInfo}
                                isShowcaseForRealMoney={category.isContainBundlesForReal}
                                key={`bundle_group_${currentPage?.name}_${group}`}
                                isSoundAvailable={isAvailableSoundEffect}
                                isLastGroup={index === allNames.length - 1}
                                ref={(ref: HTMLDivElement) => {
                                    if (ref) {
                                        refs.current.set(group, ref);
                                    }
                                }}
                            />
                        );
                    })}
                </div>
                {isHiddenProductsInfo && (
                    <div className={styles.loginRequired}>
                        <Attention label={t('Авторизуйтесь, чтобы увидеть подробную информацию о продуктах.')} buttonText={t('Авторизоваться')} onButtonClick={redirectToLogin} />
                    </div>
                )}
                {!isVisiblePopup && <EasterEgg />}
            </div>
        </div>
    );
};

export default GroupingPage;
